import { render, staticRenderFns } from "./InsideLayout.vue?vue&type=template&id=448740a5&scoped=true&"
import script from "./InsideLayout.vue?vue&type=script&lang=js&"
export * from "./InsideLayout.vue?vue&type=script&lang=js&"
import style0 from "./InsideLayout.vue?vue&type=style&index=0&id=448740a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448740a5",
  null
  
)

export default component.exports